import {DataListModel} from '../interface';
import {Flat} from './flat.model';

export class Flats extends DataListModel {
  items: Flat[] = [];
}
